import { Box } from "@mui/material";
import { CustomStyles, getStyles } from "src/styles/theme";
import defaultStyles, { StylesClasses } from "./styles";
import React from "react";

type ViewFormProps = {
  customStyles?: CustomStyles<StylesClasses>;
  label: string;
  value?: string | number;
  date?: string;
  labelStyles?: React.CSSProperties;
  valueStyles?: React.CSSProperties;
  tableValue?: React.ReactNode;
  noDot?: boolean;
};

const ViewForm = ({
  label,
  value,
  customStyles,
  date,
  labelStyles,
  valueStyles,
  tableValue,
  noDot,
}: ViewFormProps) => {
  const styles = getStyles<StylesClasses>(defaultStyles, customStyles);

  const formatValue = (val?: string | number) => {
    if (val === null || val === undefined || val === "") {
      return "-";
    }

    if (typeof val === "number") {
      if (!Number.isFinite(val)) return val;
      return val.toString();
    }

    if (typeof val === "string") {
      const num = Number(val);
      if (!Number.isNaN(num) && val.includes(".")) {
        return num.toString();
      }
      return val;
    }

    return val as any;
  };

  const displayValue = formatValue(value);

  return (
    <Box {...styles("wrapper")}>
      <Box {...styles("label")} style={labelStyles}>
        {label} {!noDot && ":"}
      </Box>
      <Box {...styles("value")} style={valueStyles}>
        {displayValue}
      </Box>
      {date && <Box {...styles("date")}>{!!date ? date : "-"}</Box>}
      {tableValue && (
        <Box {...styles("date")}>{!!tableValue ? tableValue : "-"}</Box>
      )}
    </Box>
  );
};

export default ViewForm;
